export default {
  home: {
    hero: {
      badge: 'Orquestación de entregas con agentes',
      title: 'Agentes de IA que gestionan tus entregas,',
      titleEnd: 'con las reglas que tú defines.',
      description: 'Geofleet planifica rutas, despacha cada pedido, sigue cada parada en vivo y captura la prueba de entrega. Los agentes hacen el trabajo rutinario dentro de los límites que configuras, y tu equipo solo interviene cuando importa.',
      feedTitle: 'Agentes en acción',
      feedLive: 'En vivo',
      feedFoot: 'Actividad de ejemplo · con tus límites',
      feedCta: 'Ver los agentes',
      feed: [
        { text: 'El agente de despacho asignó ODR-78262 a Amit Kumar', meta: 'Puntuación 92 · 3,1 km · aceptado en 6 s' },
        { text: 'Replanificadas 4 paradas por un corte de carretera', meta: 'Hebbal · ETA dentro de la ventana' },
        { text: 'El guardián de SLA marcó la parada 12 en riesgo, 18 min tarde', meta: 'Reasignación propuesta para aprobación' },
        { text: 'Nuevos ETA enviados a 2 clientes por WhatsApp', meta: 'ODR-78251 · ODR-78264' },
        { text: 'Prueba de entrega capturada: foto, firma, OTP', meta: 'ODR-78240 · Priya Nair · 14:14' },
        { text: '3 liquidaciones conciliadas, 1 marcada para revisión', meta: 'Zona Norte · ₹1.850 pendiente' },
      ],
      ctaPrimary: 'Empieza gratis',
      ctaSecondary: 'Reservar una demo',
      microTrust: 'Prueba gratuita de 7 días en Lite · Planes desde $39/mes',
      countries: '20+ países',
      customers: '100+ clientes',
      orders: 'Más de 1M pedidos procesados',
      industriesHeading: 'Sectores que atendemos',
      trustedBy: 'Equipos de operaciones en más de 20 países confían en nosotros',
      imageAlt: 'Centro de mando de Geofleet zona Norte: 96 % a tiempo, 24 conductores activos, mapa en vivo con dos paradas retrasadas y Copilot sugiriendo mover las paradas 12 y 14 a un conductor cercano con capacidad',
      phoneTrackingAlt: 'Página de seguimiento de marca en un móvil con mapa en vivo y datos del conductor',
      phoneDriverAlt: 'Pantalla de inicio de la app del conductor Geofleet con cronómetro de turno y viaje actual',
      chipDelta: '+2 % vs ayer', chipCopilot: 'Arreglo sugerido por Copilot', chipCopilotText: 'Reasignar 2 paradas tarde · ETA de vuelta en ventana',
      chipCustomer: 'Cliente avisado', chipCustomerText: 'ETA en vivo enviado por SMS y WhatsApp',
      cityAlt: 'Vista aérea de una autopista urbana al atardecer con camiones y furgonetas de reparto siguiendo rutas azules luminosas y paradas numeradas',
      statOnTimeLabel: 'Entregas a tiempo',
      statOnTimeValue: '96%',
      statCostLabel: 'Menor coste de entrega',
      statCostValue: '20–30%',
      statRiderLabel: 'Uso de conductores',
      statRiderValue: '+22%',
      capRoute: 'Optimización de rutas',
      capDispatch: 'Despacho automático',
      capTracking: 'Seguimiento en vivo',
      capPod: 'Prueba de entrega',
      trustedLine: 'Más de 100 equipos de operaciones en más de 20 países confían en nosotros',
      statSource: 'Resultados de casos de éxito de clientes',
      announceBadge: 'Nuevo',
      announceText: 'Presentamos Geofleet Command: agentes de IA configurados para tu red',
      announceCta: 'Ver planes',
      proofSecurity: 'Certificación SOC 2 e ISO 27001',
      costLine: 'menos coste de entrega, según casos de clientes',
      chooser: {
        subtitle: 'Elige la opción que encaja con tu operación.',
        close: 'Cerrar',
        title: '¿Desde dónde repartes?',
        liteTitle: 'Un hub, hasta 25 conductores',
        liteText: 'Geofleet Lite · prueba gratuita de 7 días, luego desde $39/mes',
        commandTitle: 'Varios hubs o más de 25 conductores',
        commandText: 'Geofleet Command · agentes de IA y flujos configurables, desde $19 por conductor',
      },
    },
    proofBar: {
      stats: [
        { value: '100+', label: 'Clientes' },
        { value: '20+', label: 'Países' },
        { value: '95%', label: 'Tasa de puntualidad' },
        { value: '99,99%', label: 'Disponibilidad' },
        { value: '50+', label: 'Integraciones' },
      ],
    },
    exceptionStory: {
      eyebrow: 'Centro de comando + Copilot',
      title: 'Un conductor con retraso, resuelto automáticamente',
      subtitle: 'Geofleet detecta el problema, prepara la solución y avisa a todos. Tu equipo solo interviene para aprobar.',
      steps: [
        {
          title: 'Detectado automáticamente',
          body: 'En cuanto un conductor se retrasa, Geofleet marca las paradas en riesgo y las sube al principio de la cola. Nadie tiene que buscarlas.',
        },
        {
          title: 'Explicado, no solo alertado',
          body: 'Copilot le dice al equipo qué va con retraso y por qué, por ejemplo tráfico en la circunvalación. Cualquiera puede hacer una pregunta de seguimiento en lenguaje natural.',
        },
        {
          title: 'Solución preparada para ti',
          body: 'Encuentra el conductor más cercano con capacidad libre y prepara la reasignación con las nuevas ETAs, lista para aprobar con un toque o automática dentro de tus reglas.',
        },
        {
          title: 'Todos actualizados automáticamente',
          body: 'Las apps de ambos conductores se actualizan, los clientes reciben una nueva ETA por SMS o WhatsApp y el cambio queda registrado. Sin llamadas ni mensajes que enviar.',
        },
      ],
      /** Labels on the screenshot for each step (sample data). */
      annotations: [
        { status: 'Riesgo detectado automáticamente', detail: 'Parada 12 · 18 min de retraso' },
        { status: 'Resumen de Copilot', detail: 'Causa: tráfico en la circunvalación' },
        { status: 'Solución lista para aprobar', detail: 'Pasar 2 paradas a Amit Kumar' },
        { status: 'Hecho automáticamente', detail: 'Clientes notificados por WhatsApp' },
      ],
      footnote: 'Elige qué se ejecuta automáticamente y qué espera aprobación. Cada acción queda registrada.',
      cta: 'Ver los agentes de IA',
      /** Caption under the step screenshots, which use illustrative data. */
      mock: { sample: 'Datos de ejemplo' },
    },
    platformCapabilities: {
      eyebrow: 'Plataforma',
      title: 'Capacidades de una',
      titleHighlight: 'plataforma empresarial',
      subtitle: 'Geofleet planifica, despacha, rastrea y prueba cada entrega desde una sola plataforma. Elige una capacidad para verla en el producto.',
      explore: 'Explorar',
      prev: 'Capacidad anterior',
      next: 'Siguiente capacidad',
      pause: 'Pausar',
      play: 'Reproducir',
    },
    industryImpact: {
      eyebrow: 'Historias de clientes',
      title: 'Impacto probado en',
      titleHighlight: 'todos los grandes sectores',
      subtitle: 'Restaurantes, supermercados, farmacias, redes de paquetería y 3PL operan con Geofleet. Cada historia es de un cliente real, anónimo a petición suya.',
      challenge: 'El reto',
      solution: 'La solución',
      readCaseStudy: 'Leer el caso de éxito',
      industryPage: 'Geofleet para este sector',
      allCaseStudies: 'Ver todos los casos de éxito',
    },
    whyGeofleet: {
      eyebrow: 'Por qué Geofleet',
      title: 'Por qué los equipos de entrega',
      titleHighlight: 'eligen Geofleet',
      subtitle: 'Un centro de mando operado por agentes sobre las herramientas de prueba, efectivo y conductores que ya necesitas, con cifras que lo respaldan.',
      items: {
        dispatch: { title: 'Un despacho que funciona solo', body: 'Un agente siempre activo asigna cada pedido a un conductor o transportista en segundos y lo ofrece en la app del conductor. Los despachadores solo ven las excepciones.' },
        onTime: { title: 'A tiempo, cada día', body: 'ETA en vivo, reasignación en cada evento y alertas de SLA mantienen las rutas en horario cuando el día se tuerce.' },
        cost: { title: 'Menor coste por entrega', body: 'Rutas más llenas, menos intentos fallidos y cero despacho manual quitan entre un 20 y un 30 % del coste de cada parada.' },
        reliability: { title: 'Hecho para escalar y auditar', body: 'SOC 2 e ISO 27001, 99,99 % de disponibilidad y un rastro de decisión por cada asignación, para que operaciones y finanzas confíen en las cifras.' },
        integrations: { title: 'Encaja con tu stack', body: 'Pedidos desde tu tienda o ERP, avisos por WhatsApp y SMS, efectivo conciliado con tu contabilidad. Sandbox, webhooks y API para el resto.' },
        global: { title: 'Listo para cada mercado', body: 'Equipos en más de 20 países usan Geofleet con el panel y la app del conductor en cuatro idiomas y precios en moneda local.' },
      },
      labels: { order: 'Pedido', matched: 'Asignado', accepted: 'Aceptado', onTimeRate: 'Tasa de puntualidad', lowerCost: 'Menos coste por entrega', manual: 'Manual', uptime: 'Disponibilidad', integrations: 'Integraciones', countries: 'Países' },
    },
    integrationsHub: {
      eyebrow: 'Integraciones',
      title: 'Conectado sin fricción con',
      titleHighlight: 'más de 50 integraciones nativas',
      subtitle: 'Los pedidos entran desde tu tienda, POS o ERP, los avisos salen a los clientes y el efectivo se concilia con tu contabilidad. Model Context Protocol permite que tus propias herramientas de IA trabajen con los mismos datos.',
      hubLabel: 'Centro de mando',
      categories: { commerce: 'Comercio & fuentes de pedidos', erp: 'ERP, contabilidad & CRM', automation: 'Automatización & IA', messaging: 'SMS & email', payments: 'Pagos & alertas de equipo', maps: 'Mapas & transportistas' },
      soon: 'Próximamente',
      cta: 'Ver todas las integraciones',
      apiDocs: 'Documentación de la API',
    },
    lifecycle: {
      eyebrow: 'Cómo funciona',
      title: 'Seis pasos del pedido a la prueba de entrega',
      cta: 'Ver cómo funciona',
      scrollHint: 'Desplázate para seguir un pedido desde la importación hasta la prueba de entrega.',
      /** Status pill and detail chip shown on the visual for each step (sample data). */
      annotations: [
        { status: 'Importando pedidos', detail: '312 pedidos · 3 requieren atención' },
        { status: 'Rutas optimizadas', detail: '4 rutas · 312 paradas planificadas' },
        { status: 'Despachado', detail: 'Ruta enviada a la app de Amit Kumar' },
        { status: 'En vivo en el mapa', detail: 'Parada 12 reordenada · ETA 11:38 AM' },
        { status: 'Cliente notificado', detail: 'Enlace de seguimiento enviado por WhatsApp' },
        { status: 'Entregado', detail: 'Foto, firma y OTP registrados' },
      ],
      stepShort: ['Importar', 'Planificar', 'Despachar', 'Seguir', 'Notificar', 'Probar'],
    },
    industryTabs: {
      eyebrow: 'Hecho para tu sector',
      title: 'Una plataforma, adaptada a tu forma de entregar',
      cta: 'Explorar {{industry}}',
      all: 'Todos los sectores',
    },
    pricingTeaser: {
      eyebrow: 'Precios',
      title: 'El precio está en la página',
      subtitle: 'Ambos parten de un precio mensual con conductores y pedidos incluidos. Lite gestiona un hub con un plan fijo; Command escala por conductor en varios hubs.',
      perDriver: '/conductor/mes',
      compare: 'Comparar planes',
      startFree: 'Empieza ahora',
    },
    problemSection: {
      eyebrow: 'La realidad de última milla',
      title: 'El despacho manual está rompiendo la eficiencia de última milla',
      subtitle:
        'Cuando la asignación vive en chats, llamadas y hojas de cálculo, estos síntomas son inevitables—y se acumulan en cada pico.',
      pains: [
        {
          title: 'Entregas retrasadas',
          description:
            'Los pedidos esperan una decisión humana mientras el tráfico, la capacidad y los SLA avanzan: los retrasos se acumulan y se pierden clientes.',
        },
        {
          title: 'Conductores ociosos',
          description:
            'Hay capacidad sin usar en una zona mientras la demanda sube en otra porque el despacho no puede reasignar a tiempo.',
        },
        {
          title: 'Sobrecarga del despachador',
          description:
            'En picos el equipo se convierte en centralita manual: triage, reasignación y retrabajo devoran horas que deberían escalar.',
        },
        {
          title: 'ETAs inconsistentes',
          description:
            'Las ventanas prometidas se desvían de la realidad si los planes no están ligados a ubicación en vivo, carga y estado de ruta.',
        },
        {
          title: 'Ineficiencia operativa',
          description:
            'El coste por parada sube: kilómetros extra, horas extra y excepciones sustituyen una ejecución optimizada y repetible.',
        },
      ],
    },
    outcomes: {
      eyebrow: 'Resultados — no listas de funciones',
      title: 'Qué cambia cuando el despacho es en tiempo real',
      subtitle:
        'Los equipos adoptan Geofleet para mover KPIs reales: menos retrasos, rutas más llenas y despachadores en excepciones—no en hojas de cálculo.',
      items: [
        {
          headline: '30%',
          trend: 'down',
          title: 'Retrasos en la entrega',
          sub: 'Menos incidencias de retraso frente a asignación manual.',
        },
        {
          headline: '25%',
          trend: 'up',
          title: 'Uso de conductores',
          sub: 'Más paradas productivas cuando los pedidos encajan con la capacidad en vivo.',
        },
        {
          headline: '80%',
          trend: 'down',
          title: 'Esfuerzo manual de despacho',
          sub: 'Menos tiempo en reasignaciones, llamadas y rework en picos.',
        },
        {
          headline: 'En plazo',
          trend: 'up',
          title: 'Tasa de entrega',
          sub: 'Mejor cumplimiento de SLA cuando los ETA reflejan la ruta en vivo.',
        },
      ],
    },
    roiCalculator: {
      eyebrow: 'Vista ROI',
      title: 'Estima tu ahorro mensual',
      subtitle:
        'Modelo rápido con tu volumen, flota y coste de retrasos—afina con nuestro equipo en tu red real.',
      ordersLabel: 'Pedidos por día',
      ridersLabel: 'Conductores / riders',
      delayCostLabel: 'Coste medio de retraso por pedido ($)',
      ordersHelp: 'Volumen medio diario que despachas.',
      ridersHelp: 'Conductores activos en última milla.',
      delayCostHelp: 'Coste mixto de un retraso o entrega subóptima (CX, nueva entrega, tasas).',
      outputLabel: 'Ahorro mensual estimado',
      breakdownDelays: 'Por menos retrasos (30%)',
      breakdownUtil: 'Por mayor utilización (25%)',
      breakdownManual: 'Por menos despacho manual (80% del esfuerzo típico)',
      disclaimer:
        'Solo ilustrativo—no es asesoramiento financiero ni garantía. Los resultados reales dependen de red, SLA y adopción. Reserva una demo para un modelo a medida.',
      cta: 'Reservar demo para validar',
      ctaSecondary: 'Hablar con ventas',
    },
    aiAgents: {
      eyebrow: 'Agentes de IA para logística',
      title: 'Despachan, reenrutan y resuelven antes de que tu equipo tenga que hacerlo',
      intro:
        'Geofleet despliega flujos agénticos en tu torre de control: transportistas y conductores se emparejan en tiempo real, las rutas se replanifican cuando cambia el tráfico o el volumen, y el riesgo de SLA aparece con contexto—para que el crecimiento no dependa de playbooks manuales de despacho.',
      cta: 'Explorar agentes de IA',
    },
    trust: {
      title: 'Una torre de control. Agentes de IA con el trabajo pesado.',
      subtitle: 'Automatiza las decisiones que antes quemaban horas de despacho—sin reemplazar todo tu stack.',
      benefits: [
        {
          title: 'Despacho y asignación agénticos',
          description:
            'Los agentes de IA emparejan cada envío con el transportista y conductor adecuados según capacidad, coste, SLA, habilidades y condiciones en vivo—de forma continua, no en lotes nocturnos.',
        },
        {
          title: 'Rutas que se replanifican solas',
          description:
            'Si cambia el tráfico, falla un intento o entran pedidos a mitad de ruta, la planificación agéntica se adapta sin reconstruir tours en hojas de cálculo.',
        },
        {
          title: 'Excepciones resueltas en la torre',
          description:
            'Alertas proactivas por riesgo de SLA, retrasos y cuellos de capacidad—priorizadas por la IA para que las personas arreglen lo crítico y los agentes limpien el resto.',
        },
        {
          title: 'Visibilidad que confían dirección y clientes',
          description:
            'ETAs predictivos, seguimiento de marca y mapas en vivo alimentados por el mismo modelo agéntico que usa despacho—una sola versión de la verdad.',
        },
      ],
    },
    howItWorks: {
      badge: 'Centro de comando',
      title: 'Una torre para',
      titleHighlight: 'chatear y mandar',
      subtitle:
        'Todo ocurre en el centro de comando: chatea con Copilot para planificar y corregir, deja que ejecute acciones masivas y termina el despliegue con onboarding asistido por IA—sin saltar entre herramientas.',
    },
    howItWorksBlocks: {
      pillarsSectionEyebrow: 'Cómo funciona',
      pillarsSectionTitle: 'Dos superficies—no una lista interminable',
      pillarsIntro:
        'Abajo está dividido en Centro de comando (operación en vivo) y Copilot (IA sobre los mismos datos). Cuatro capacidades compactas cada uno—fácil de escanear.',
      flowSectionTitle: 'Cómo encaja el recorrido',
      flowSectionIntro: 'Primero la torre, luego Copilot, ejecución e onboarding guiado—la misma historia, paso a paso.',
      steps: {
        commandCentre: 'Centro de comando',
        copilot: 'Copilot',
        execute: 'Ejecutar y automatizar',
        aiOnboarding: 'Onboarding con IA',
      },
      stepBlurbs: {
        commandCentre: 'Mapa en vivo, colas y controles: una sola superficie para toda la operación.',
        copilot: 'Pregunta en lenguaje claro: asignar rutas, resolver excepciones y ver estado.',
        execute: 'Convierte respuestas en actualizaciones masivas, re-rutas y flujos sin cambiar de pestaña.',
        aiOnboarding: 'Configuración guiada de integraciones, hubs y roles—Copilot acompaña a tu equipo.',
      },
      majorFeatures: [
        {
          kicker: 'Operaciones',
          title: 'Centro de comando',
          subtitle:
            'Una vista en vivo de cada pedido, conductor y parada, con las métricas y el registro de auditoría detrás.',
          cards: [
            {
              title: 'Mapa y colas en vivo',
              line: 'Ve entregado, en tránsito y en riesgo juntos—las excepciones suben arriba.',
            },
            {
              title: 'Conecta tu stack',
              line:
                'Integraciones nativas, MCP para herramientas de IA, CSV masivo o datos maestros manuales—conductores, vehículos, hubs, pedidos.',
            },
            {
              title: 'Planifica y cambia rápido',
              line: 'Despacho, reasignación, actualizaciones masivas y manifiestos donde lo permita tu política.',
            },
            {
              title: 'Insights y auditoría',
              line: 'KPIs y desglose de retrasos; exportaciones e historial para CX, finanzas y cumplimiento.',
            },
          ],
        },
        {
          kicker: 'Automatización con IA',
          title: 'Copilot y agentes de IA',
          subtitle:
            'Vigilan las operaciones en vivo, preparan soluciones y actúan dentro de tus reglas, para que las incidencias rutinarias se resuelvan solas.',
          cards: [
            {
              title: 'Detecta problemas a tiempo',
              line: 'Conductores con retraso, intentos fallidos y riesgo de SLA se marcan en el momento en que ocurren.',
            },
            {
              title: 'Prepara la solución',
              line: 'Reasignaciones, cambios de ruta y avisos a clientes quedan listos para aprobar con un toque.',
            },
            {
              title: 'Actúa dentro de tus reglas',
              line: 'Las acciones rutinarias se ejecutan solas; todo lo que supere tus límites vuelve a una persona.',
            },
            {
              title: 'Explica cuando lo pides',
              line: 'Pregunta «¿qué cambió desde las 09:00?» y obtén respuestas basadas en datos en vivo, no texto genérico de IA.',
            },
          ],
        },
      ],
      seeInAction: 'Ver en acción',
      howItWorksLink: 'Cómo funciona',
      bottomCtaTitle: '¿Listo para gestionar tus entregas a tu manera?',
      bottomCtaSub: 'Una sola vista de CX y operaciones — sin hojas de cálculo.',
    },
    platformCarousel: {
      badge: 'Torre de control',
      title: 'Descubre Geofleet en acción',
      subtitle: 'La misma superficie que usan tus agentes: despacho, mapa en vivo, rutas y analíticas en un solo lugar.',
      slides: [
        { title: 'Panel de despacho', description: 'Un centro donde agentes y despachadores asignan, reequilibran y resuelven excepciones en vivo' },
        { title: 'Planificación de rutas', description: 'Enrutamiento agéntico que reacciona a tráfico, ventanas y nuevo volumen—más allá de rutas estáticas' },
        { title: 'Seguimiento al cliente', description: 'Seguimiento de marca con ETAs alimentadas por el mismo modelo en vivo que tu torre' },
        { title: 'Análisis e informes', description: 'Ve qué movieron agentes y conductores—y dónde la automatización recuperó tiempo y margen' },
      ],
    },
    transformation: {
      badge: 'Transformación',
      title: 'Lo que Geofleet hace por tus',
      titleHighlight: 'operaciones logísticas',
      subtitle: 'De flujos manuales y fragmentados a una torre de control con IA — descubre el cambio.',
      withoutGeofleet: 'Sin Geofleet',
      withGeofleet: 'Con Geofleet',
      controlTower: 'Torre de control con IA',
      exploreFeatures: 'Explorar funciones',
      beforeItems: [
        'Horas dedicadas al despacho manual y la planificación de rutas',
        'Sin visibilidad en tiempo real — clientes y operaciones a ciegas',
        'Hojas de cálculo y múltiples herramientas que no se conectan',
        'Entregas tardías, pruebas de entrega fallidas y disputas',
        'Pérdida de ingresos por COD, reembolsos e ineficiencia',
      ],
      afterItems: [
        'Los agentes de IA despachan y optimizan rutas en segundos',
        'Seguimiento en vivo, ETAs y páginas de seguimiento con tu marca',
        'Una torre de control para flota, pedidos y análisis',
        'ePOD, firma electrónica, OTP — menos disputas, pruebas listas para auditoría',
        'Recupera ingresos, reduce costes y escala con confianza',
      ],
      joinTeams: 'Únete a los equipos que ya han dado el paso',
      stat1: '20–30% de reducción de costes',
      stat2: '95% entregas a tiempo',
      stat3: 'Cero despacho manual',
    },
    scaleImpact: {
      title: 'Las operaciones de flota funcionan con',
      titleBrand: 'Geofleet',
      subtitle: 'Desde un solo hub hasta flotas multinacionales—agentes de IA y personas en una torre de última milla.',
      stats: [
        { label: 'Tasa de entrega a tiempo' },
        { label: 'Reducción de costes' },
        { label: 'Eficiencia del conductor' },
        { label: 'Operaciones con IA' },
      ],
      multiRegion: 'Multi-región',
      enterpriseReady: 'Listo para empresa',
      integrations: 'Más de 50 integraciones',
    },
    trustedLeaders: {
      badge: 'Con la confianza de líderes del sector',
      title: 'Los equipos empresariales confían en',
      titleBrand: 'Geofleet',
      subtitle: 'Desde startups en crecimiento hasta logística Fortune 500 — empresas que procesan millones de entregas confían en Geofleet para impulsar sus operaciones.',
      testimonials: [
        { quote: 'El despacho con IA de Geofleet eliminó la mayor parte de nuestro enrutamiento manual. Escalamos las entregas diarias de recetas sin añadir despachadores: cumplimiento y entrega a tiempo mejoraron en todos los frentes.', author: 'Responsable de operaciones', role: 'Farmacia', company: 'Qatar', metric: 'Entregas escaladas' },
        { quote: 'El motor de ETA predictivo redujo significativamente las llamadas de quejas. Nuestros clientes empresariales nos consideran ahora referentes en entrega de última milla en la región.', author: 'Jefe de logística', role: 'Empresa de logística', company: 'EAU', metric: '70% menos quejas' },
        { quote: 'Integramos Geofleet en nuestros equipos de campo en semanas. La plataforma gestiona despacho, visibilidad del conductor y prueba de entrega para que podamos centrarnos en disponibilidad y seguridad.', author: 'Gestor de flota', role: 'Empresa de energía renovable', company: 'India', metric: 'Despliegue más rápido' },
      ],
      stats: [
        { value: '100+', label: 'Clientes' },
        { value: '1M+', label: 'Entregas procesadas' },
        { value: '20+', label: 'Países' },
        { value: '99,99%', label: 'Disponibilidad de la plataforma' },
        { value: '24/7', label: 'Soporte empresarial' },
      ],
      badges: [
        { label: 'Conformidad SOC 2' },
        { label: 'Conformidad GDPR' },
        { label: 'SLA 99,99%' },
        { label: 'SSO' },
        { label: 'API-First' },
      ],
    },
    driverExperience: {
      badge: 'Experiencia del conductor',
      title: 'Una app para conductores que',
      titleHighlight: 'realmente les encantará',
      subtitle: 'Diseñada para rapidez y simplicidad. Todo lo que un conductor necesita para completar entregas más rápido — y nada más.',
      features: [
        { title: 'Rutas optimizadas con IA', description: 'Navegación paso a paso con desvíos por tráfico en tiempo real. Los conductores siempre toman la ruta más rápida.', stat: '30% más rápido' },
        { title: 'Prueba de entrega inteligente', description: 'Fotos verificadas por IA, firmas electrónicas y confirmación OTP — todo con un toque.', stat: 'POD en 1 toque' },
        { title: 'Cola de tareas inteligente', description: 'La IA ordena las paradas por prioridad, ventanas horarias y proximidad. Sin suposiciones, sin incumplir SLAs.', stat: '95% a tiempo' },
        { title: 'Comunicación en la app', description: 'Llamadas con un toque, números enmascarados y chat con el despachador — sin salir de la app.', stat: 'Cero fricción' },
        { title: 'Escaneo de código de barras e ID', description: 'Escanea códigos de paquetes y verifica el ID del cliente para entregas con restricción de edad o alto valor.', stat: '100% verificado' },
        { title: 'Listo sin conexión', description: 'Todas las funciones en zonas sin cobertura. Los datos se sincronizan al recuperar la conexión.', stat: 'Siempre activo' },
      ],
      delivered: 'Entregado',
      orderId: '#1246',
      rating: 'Valoración',
      ratingValue: '4.9/5',
      availableOn: 'Disponible en iOS y Android',
      downloadOnThe: 'Descargar en',
      appStore: 'App Store',
      getItOn: 'Consíguelo en',
      googlePlay: 'Google Play',
      appStoreRating: '4.9 en App Store',
    },
    coreFeatures: {
      badge: 'IA + plataforma',
      title: 'Descubre Geofleet en acción',
      subtitle: 'Despacho, enrutamiento agéntico, seguimiento y analíticas—todo lo que necesitan tus agentes y equipos en un stack.',
      platformLine: 'Profundidad de producto y visibilidad empresarial—agentes y personas con los mismos datos en vivo.',
      carousel: {
        dispatch: 'Despacho',
        routes: 'Rutas',
        tracking: 'Seguimiento',
        analytics: 'Análisis',
        dispatchHeadline: 'Un centro para cada pedido y cada conductor',
        dispatchDescription: 'Gestiona el despacho desde una sola pantalla: asigna conductores, actualiza estado y gestiona excepciones en tiempo real. Sin hojas de cálculo ni pedidos perdidos.',
        routesHeadline: 'Rutas optimizadas por IA en segundos',
        routesDescription: 'Nuestro motor tiene en cuenta tráfico, ventanas horarias y capacidad para reducir kilómetros y combustible. Más paradas por ruta con menos planificación.',
        trackingHeadline: 'Seguimiento con tu marca, mapa en vivo y ETA',
        trackingDescription: 'Ofrece a cada cliente una página de seguimiento con tu logo y un mapa en vivo. Menos llamadas de «¿dónde está mi pedido?» y mejores valoraciones.',
        analyticsHeadline: 'Insights que mejoran el rendimiento',
        analyticsDescription: 'Tiempos de entrega, tasas de puntualidad, fichas de conductores y coste por entrega — todo en cuadros de mando para mejorar cada semana.',
      },
      learnMore: 'Saber más',
      whatIncluded: 'Qué incluye',
      stats: { eta: 'Precisión ETA', savings: 'Ahorro en rutas', disputes: 'Menos disputas' },
      ctaDemo: 'Reservar demo',
      ctaTrial: 'Empezar',
      pillarsCrossLink:
        'Centro de comando y Copilot están en «Cómo funciona» arriba — este carrusel muestra las cuatro superficies clave del producto.',
      pillarsCrossLinkCta: 'Ir a Cómo funciona',
    },
    integrations: {
      label: 'Integraciones',
      title: 'Model Context Protocol para tu stack de entregas',
      paragraph:
        'Geofleet admite MCP para que asistentes y agentes trabajen con contexto estructurado y con permisos sobre tus operaciones, junto con conectores nativos para más de 10 SMS, más de 10 email, más de 10 pasarelas de pago, más de 5.000 dispositivos IoT y más de 10 OMS como Shopify y Unicommerce. Un protocolo para la IA; cobertura completa en SMS, email, pagos, IoT y pedidos.',
      learnMore: 'Saber más',
      footerLine: 'MCP · SMS · Email · WhatsApp · Line · Pagos · OMS · IoT · POS · Entrega',
    },
    demoCta: {
      title: 'Pon a trabajar agentes de IA en tu logística',
      subtitle: 'Más de 100 empresas gestionan despacho, rutas y excepciones desde una torre Geofleet',
      ctaTrial: 'Empieza ahora',
      ctaDemo: 'Reservar una demo',
      noCard: 'Lite desde $49/mes, prueba gratuita de 7 días',
      freeTrial: 'Command desde $190/mes para 10 conductores',
      cancelAnytime: 'Cancela cuando quieras',
    },
    faq: {
      supportLabel: 'Soporte',
      title: 'Preguntas frecuentes',
      subtitle: 'Respuestas rápidas sobre Geofleet y cómo empezar.',
      items: [
        { question: '¿Qué es Geofleet?', answer: 'Geofleet es una plataforma de gestión de entregas y flotas con agentes de IA en la torre de control. Automatiza asignación de transportistas y conductores, planificación agéntica de rutas, alertas de SLA y flujos de excepción—con seguimiento en tiempo real, ETAs predictivos, ePOD y analíticas en múltiples hubs, conductores e integraciones.' },
        { question: '¿Cómo empiezo?', answer: 'Si repartes desde un solo hub, empieza con Geofleet Lite desde $49 al mes con 3 conductores y 500 pedidos, y una prueba gratuita de 7 días. Lite Plus ($99) añade rutas, asignación automática, WhatsApp y API, y Lite Autopilot ($179) añade AI Copilot y Autopilot. Los equipos con varios hubs empiezan en Geofleet Command desde $190 al mes para 10 conductores.' },
        { question: '¿Geofleet funciona con mis herramientas actuales?', answer: 'Sí. Geofleet se integra con más de 10 proveedores SMS, más de 10 de email, más de 10 pasarelas de pago, más de 5.000 dispositivos IoT y más de 10 OMS como Shopify y Unicommerce, además de POS y socios de entrega. También ofrecemos API y webhooks para integraciones personalizadas.' },
        { question: '¿Cuánto cuesta Geofleet?', answer: 'Geofleet Lite empieza en $49 al mes con 3 conductores y 500 pedidos desde un hub; Lite Plus cuesta $99 y Lite Autopilot $179. Geofleet Command empieza en $190 al mes para 10 conductores y 5.000 pedidos en Professional, es decir $19 por conductor; Premium AI cuesta $29 por conductor. Enterprise es personalizado.' },
        { question: '¿Soportáis múltiples ubicaciones y hubs?', answer: 'Sí. Geofleet está diseñado para operaciones multi-hub y multi-región. Puedes gestionar varios almacenes, cocinas fantasma o tiendas desde un único panel, con acceso por roles, análisis por hub y despacho con IA que considera todas las ubicaciones.' },
        { question: '¿Qué tipo de soporte ofrecéis?', answer: 'Ofrecemos soporte por email, ayuda en la app y documentación en todos los planes. Los niveles superiores incluyen soporte prioritario y gestores de éxito dedicados. También puedes reservar una demo o hablar con ventas para requisitos personalizados.' },
      ],
    },
  },
};
